import Vue from 'vue';
import Router from 'vue-router';

const Login = () => import('@/components/Login');
const Registration = () => import('@/components/Registration');
const ForgotPassword = () => import('@/components/ForgotPassword');
const ResetPassword = () => import('@/components/ResetPassword');
const ChangePassword = () => import('@/components/ChangePassword');
const LoginSuccess = () => import('@/components/LoginSuccess');
const CookieDetails = () => import('@/components/CookieDetails');
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Registration',
      name: 'Registration',
      component: Registration
    },
    {
      path: '/ForgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/ChangePassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/LoginSuccess',
      name: 'LoginSuccess',
      component: LoginSuccess
    },
    {
      path: '/CookieDetails',
      name: 'CookieDetails',
      component: CookieDetails
    },
    { path: '*', component: Login }
  ]
})
